import { useTranslation } from 'react-i18next';

const CartFullModal = (props) => {
  const theme = JSON.parse(localStorage.getItem('machine'))?.themeColor;
  let cartStyle = () => {
    let text = 'Your cart is full';
    if (theme?.addToCartStyle === '1') {
      text = 'Your bag is full';
    }
    return text;
  };
  const { t } = useTranslation();
  const { show, setCartFull } = props;
  if (show) {
    return (
      // <Modal show={show} onHide={setCartFull(false)}>
      <div
        className="fullcart-modal"
        onClick={() => {
          setCartFull(false);
        }}
      >
        <div className="fullcart-modal-container">
          <div className="fullcart-modal-title">{t(`Oops`)}!</div>
          <div className="fullcart-modal-title1">{t(cartStyle())}.</div>
          <div className="fullcart-modal-title2">
            {t(`Please checkout with your current items before placing another order.`)}
          </div>
        </div>
      </div>
    );
  } else return null;
};

export default CartFullModal;
